/*
 Sohel 03/16/2023 2789721057 Integrated Save API
 Dilip 03/16/2023 2789721057 added duplicate check validations
Rohini 03/16/2023 2789721057 design enhancements done in the screens.
 Ravi 03/16/2023 2789721057 added popover on code
 suresh peddavoora 03/23/2023 2789721057 textfield alignments fixes
Prakash 21/04/2023 2789721057 fixed button spaceing  alignments issue
Akhila 06/05/2023 2789721057 unsaved changes bug fixed/implemented
Ravi 06/26/2023 2789721057 fixed submit issue
Gireesh 12/11/2023 2789721057 Added Translation table Code validation and description
*/
import React, {useEffect, useContext, useRef, useState} from 'react';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {Button, FormHelperText, MenuItem, TextField} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import AddValueTable from './AddValueTable';
import {backButtonText} from '../../../util/Content';
import {ArrowBack} from '@material-ui/icons';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import * as Yup from 'yup';
import {Formik, Form} from 'formik';
import {
  postTranslationTableData,
  resetMainTranslation,
  fetchAllTranslationCodes,
} from '../../../redux/reducers/TranslationTable';
import {currsorCodeIssue} from '../../../components/UpperCaseCode';
import {setAlertData} from '../../../redux/reducers/UnsavedChangesAlertReducer';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';
// import { nameRegexAllow } from '../../../util/RegexPatterns';

function AddLookupMaintenance({
  setValue,
  rowData,
  handleDirty,
  showAlertRef,
  TranslationTableAccess,
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const codeRef = useRef();
  const [filterCodesData, setFilterCodesData] = useState();
  const [codePopover, setCodePopover] = useState(false);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {
    successMessage,
    errorMessage,
    isLoading,
    translationMainData,
    addTranslationStatus,
    allTranslationCodes,
  } = useSelector(({translationTableData}) => translationTableData);
  const initialVal = {
    code: translationMainData?.code ? translationMainData?.code : '',
    defaultValue: translationMainData?.defaultValue ? translationMainData?.defaultValue : '',
    description: translationMainData?.description ? translationMainData?.description : '',
  };
  const [initialValues, setInitialValues] = useState(initialVal);
  const getFilterCodesData = () => {
    if (allTranslationCodes && allTranslationCodes?.length > 0) {
      return allTranslationCodes?.filter((i) => String(i?.code)?.startsWith(filterCodesData));
    } else {
      return [];
    }
  };
  useEffect(() => {
    dispatch(fetchAllTranslationCodes());
  }, []);

  useEffect(() => {
    setInitialValues({...initialVal});
  }, [translationMainData]);

  const checkTranslationCodeExist = (value) => {
    if (allTranslationCodes && allTranslationCodes?.length > 0 && value) {
      const ar = [];
      allTranslationCodes.filter((i) => {
        if (i?.code?.toUpperCase()?.trim() === value?.toUpperCase()?.trim()) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const schema = Yup.object().shape({
    code: translationMainData?.code ?
      null :
      Yup.string()
        .required('Code is required')
        .test('code', 'Code is required', (value) => {
          if (!value) {
            return false;
          } else {
            return true;
          }
        })
        .test('code', 'Code already exist', (value) => !checkTranslationCodeExist(value)),
    description: translationMainData?.description ?
      null :
      Yup.string()
        .required('Description is required')
        .test('value', 'Description is required', (value) => {
          if (!value) {
            return false;
          } else {
            return true;
          }
        }),
  });
  useEffect(() => {
    if (successMessage || errorMessage) {
      setTimeout(() => {
        dispatch(resetMainTranslation());
      }, 2000);
    }
  }, [successMessage, errorMessage]);
  useEffect(() => {
    if (addTranslationStatus === 200 && successMessage) {
      setTimeout(() => {
        dispatch(resetMainTranslation());
        setValue(0);
      }, 2000);
    }
  }, [addTranslationStatus]);
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const payload = {
      code: values?.code ? values?.code : '',
      defaultValue: values?.defaultValue ? values?.defaultValue : '',
      description: values?.description ? values?.description : '',
      isActive: '',
      translationTableId: translationMainData?.translationTableId ?
        translationMainData?.translationTableId :
        0,
    };
    dispatch(postTranslationTableData(payload));
  };
  window.onclick = function() {
    setCodePopover(false);
  };
  return (
    <>
      <div className={`mb-0`}>
        <div className="button-table-spacing-mb justify-content-start  new-standard-textfields">
          <Button
            variant="outlined"
            type="button"
            className={`search-btn ${classes.buttonRoot}`}
            onClick={() => {
              // setValue(0);
              if (showAlertRef.current) {
                dispatch(
                  setAlertData({
                    showAlert: showAlertRef.current,
                    alertCallback: () => {
                      setValue(0);
                    },
                  }),
                );
              } else {
                setValue(0);
              }
            }}
          >
            <ArrowBack className="mr-2" />
            {backButtonText}
          </Button>
        </div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              setFieldValue,
              touched,
              errors,
              resetForm,
              handleBlur,
              dirty,
            } = props;
            if (dirty) {
              handleDirty(dirty);
            }
            return (
              <>
                <div>
                  <Form autoComplete="off" noValidate>
                    <div className="form-row global-field-textfields new-standard-textfields">
                      <div className={`col-sm-6 col-md-4 col-xl-4  ${errors?.code?.length > 30 ? 'form-group-lg' : 'form-group'}`}>
                        <TextField
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Code`}
                          label={`Code`}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          inputProps={{maxLength: 25}}
                          name="code"
                          disabled={translationMainData?.code}
                          required
                          value={values?.code}
                          onChange={(e) => {
                            const value = currsorCodeIssue(codeRef);
                            setFieldValue('code', value);
                            if (e.target.value) {
                              setCodePopover(true);
                              setFilterCodesData(e.target.value);
                            } else if (e.target.value === '') {
                              setCodePopover(false);
                            }
                          }}
                          onBlur={handleBlur}
                          fullWidth
                          inputRef={codeRef}
                          touched={touched.code}
                          error={Boolean(touched.code && errors.code)}
                        />
                        <FormHelperText>
                          {touched.code && errors?.code && errors.code}
                        </FormHelperText>
                        <div className="windowcode-popover Add-trigger-group-popover">
                          {codePopover &&
                            getFilterCodesData()?.map((data) => (
                              <MenuItem key={data?.code}>{data?.code}</MenuItem>
                            ))}
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-xl-4 form-group">
                        <TextField
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Description`}
                          label={`Description`}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          inputProps={{maxLength: 100}}
                          name="description"
                          required
                          value={values?.description}
                          onChange={(e) => {
                            setFieldValue('description', e.target.value);
                          }}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.description}
                          error={Boolean(touched.description && errors.description)}
                        />
                        <FormHelperText>
                          {touched.description && errors?.description && errors.description}
                        </FormHelperText>
                      </div>
                      <div className="col-sm-6 col-md-4 col-xl-4 form-group">
                        <TextField
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Default Value`}
                          label={`Default Value`}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          name="defaultValue"
                          value={values?.defaultValue}
                          onChange={(e) => {
                            setFieldValue('defaultValue', e.target.value);
                          }}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div>
                    </div>
                    <div className={`border-rounded mb-4`}>
                      <AddValueTable
                        rowData={rowData}
                        values={values}
                        TranslationTableAccess={TranslationTableAccess}
                      />
                    </div>
                    <div className="new-standard-textfields d-flex justify-content-center mb-1">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          resetForm(initialValues);
                        }}
                        className={`mx-1 reset-btn ${classes.buttonRoot}`}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        disabled={(rowData?.code && !TranslationTableAccess?.edit) || enabledSubmission}
                        className={`search-btn mx-1 ${classes.buttonRoot}`}
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                </div>
              </>
            );
          }}
        </Formik>
      </div>
      {isLoading && <PageLoader />}
      {successMessage && <SuccessSnackbar successMsg={successMessage} />}
      {errorMessage && <ErrorSnackbar errorMsg={errorMessage} />}
    </>
  );
}

export default AddLookupMaintenance;
